import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {Paginate} from 'vuejs-paginate';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
  faUsers,
  faSearch,
  faCog,
  faCogs,
  faTrash,
  faPlus,
  faEye
} from '@fortawesome/free-solid-svg-icons';


import VueSweetalert2 from 'vue-sweetalert2';

//ApexChart
import VueApexCharts from 'vue-apexcharts'


//Mujer
import FormularioMujer from './components/FormularioMujer.vue';
import FormularioAddMujer from './components/FormularioAddMujer.vue';
import FormularioETMI from './components/FormularioETMI.vue';
import FormularioControlMujer from './components/FormularioControlMujer.vue';
import FormularioAddVacunaMujer from './components/FormularioAddVacunaMujer.vue';


//Niños
import FormularioNinos from './components/FormularioNinos.vue';
import FormularioAddNinos from './components/FormularioAddNinos.vue';
import FormularioSaludInfatil from './components/FormularioSaludInfatil.vue';
import FormularioControlNiño from './components/FormularioControlNiño.vue';
import FormularioAddVacuna from './components/FormularioAddVacuna.vue';
import FormularioAddTamizaje from './components/FormularioAddTamizaje.vue';
import FormularioAddAnemia from './components/FormularioAddAnemia.vue';
import GraficoPeso from './components/GraficoPeso.vue';
import GraficoEstatura from './components/GraficoEstatura.vue';
import GraficoICM from './components/GraficoICM.vue';
import GraficoPerimetro from './components/GraficoPerimetro.vue';

//importaciones formularios opciones
import Discapacidad from './components/Discapacidad.vue';
import EstablecimientoSalud from './components/EstablecimientoSalud.vue';

//importaciones mujeres opciones componentes formularios
import ETMITrimestre from './components/ETMITrimestre.vue';
import ETMIVacuna from './components/ETMIVacuna.vue';
import VacunaTipoMujer from './components/VacunaTipoMujer.vue';
import VacunaDosisMujer from './components/VacunaDosisMujer.vue';
import VacunaNombreMujer from './components/VacunaNombreMujer.vue';

//importaciones niños opciones componente formularios

import VacunaClasificacionNino from './components/VacunaClasificacionNino.vue';
import VacunaTipoNino from './components/VacunaTipoNino.vue';
import VacunaDosisNino from './components/VacunaDosisNino.vue';
import TamizajeClasificacionNino from './components/TamizajeClasificacionNino.vue';

//Para reportes 
import ReporteSexo from './components/ReporteSexo.vue';
import ReportePeso from './components/ReportePeso.vue';
import ReportePrincipal from './components/ReportePrincipal.vue';
import ReporteDesnutricion from './components/ReporteDesnutricion.vue';
import ReporteVacuna from './components/ReporteVacunas.vue';
import ReporteUsuario from './components/ReporteUsuario.vue';


//Mujer components
Vue.component('formulario-mujer', FormularioMujer);
Vue.component('formulario-addmujer', FormularioAddMujer);
Vue.component('formulario-etmi', FormularioETMI);
Vue.component('formulario-controlmujer', FormularioControlMujer);
Vue.component('formulario-vacunamujer', FormularioAddVacunaMujer);
//Niños components
Vue.component('formulario-addnino', FormularioAddNinos);
Vue.component('formulario-nino', FormularioNinos);
//Panel por niños id
Vue.component('formulario-salud1', FormularioSaludInfatil);
Vue.component('formulario-salud2', FormularioControlNiño);
Vue.component('formulario-vacuna', FormularioAddVacuna);
Vue.component('formulario-tamizaje', FormularioAddTamizaje);
Vue.component('formulario-anemia', FormularioAddAnemia);
//Graficos para niños
Vue.component('grafico-peso', GraficoPeso);
Vue.component('grafico-longitud', GraficoEstatura);
Vue.component('grafico-icm', GraficoICM);
Vue.component('grafico-perimetro', GraficoPerimetro);

//FORMULARIOS OPCIONES
Vue.component('form-discapacidad', Discapacidad);
Vue.component('form-establecimiento', EstablecimientoSalud);

//ETMI OPCIONES
Vue.component('form-etmitrimestre', ETMITrimestre);
Vue.component('form-etmivacuna', ETMIVacuna);
// VACUNA MUJER OPCIONES
Vue.component('form-vacunatipomujer', VacunaTipoMujer);
Vue.component('form-vacunadosismujer', VacunaDosisMujer);
Vue.component('form-vacunanombremujer', VacunaNombreMujer);
//VACUNA Y TAMIZAJE NIÑO OPCIONES
Vue.component('form-vacunaclasificacionnino', VacunaClasificacionNino);
Vue.component('form-vacunatiponino', VacunaTipoNino);
Vue.component('form-vacunadosisnino', VacunaDosisNino);
Vue.component('form-tamizajeclasificacionnino', TamizajeClasificacionNino);

//Reportes
Vue.component('reporte-sexo', ReporteSexo);
Vue.component('reporte-peso', ReportePeso);
Vue.component('reporte-principal', ReportePrincipal);
Vue.component('reporte-desnutricion', ReporteDesnutricion);
Vue.component('reporte-vacuna', ReporteVacuna);
Vue.component('reporte-usuario', ReporteUsuario);



Vue.component('paginate', Paginate)




library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt,faUsers, faSearch, faCog , faCogs, faTrash,faPlus,faEye);

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(VueSweetalert2);

//chart apex 
Vue.use(VueApexCharts)


Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('apexchart', VueApexCharts)





Vue.use(Vuex);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
